import styles from 'client/pages/MapPage/components/DynamicLegend/DynamicLegendButton/DynamicLegendButton.module.scss';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import MapControl from 'client/pages/MapPage/components/MapControl/MapControl';
import Button from 'client/components/aria/Button/Button';
import { mdiMapLegend } from '@mdi/js';
import Icon from '@mdi/react';
import { selectShowDynamicLegend, setShowDynamicLegend } from 'client/store/mapSlice/mapSlice';

const DynamicLegendButton = () => {
    const intl = useIntl();
    const dispatch = useDispatch();
    const showLegend = useSelector(selectShowDynamicLegend);

    return <MapControl>
        <div className={styles.container}>
            <Button
                className={[showLegend ? styles.active : ''].join(' ')}
                onPress={() => dispatch(setShowDynamicLegend(!showLegend))}
                data-testid={'dynamicLegend'}
                variant='secondary'
                aria-label={intl.formatMessage({ id: 'dynamicLegend.altText' })}
            >
                <Icon path={mdiMapLegend} aria-hidden={true} />
            </Button>
        </div>
    </MapControl>;
};

export default DynamicLegendButton;
